import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';

/** Consente l'accesso solo agli amministratori (Admin/Root). */
export const adminGuard: CanActivateFn = () =>
{
    const router = inject(Router);
    return inject(UserService).isAdmin ? true : router.parseUrl('/dashboard');
};
